import { FormControlLabel, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import Checkbox from './checkbox';

const useStyles = makeStyles((theme) => ({
  root: { margin: 0 },

  label: {
    marginLeft: 8,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.43,
    letterSpacing: 'normal',
    color: theme.colors.dark,

    '&$disabled': { color: theme.colors.grey99 },
  },

  disabled: {},
}));

function FormControlCheckbox(props) {
  const { classes } = props;
  const styles = useStyles();

  return (
    <FormControlLabel
      {...props}
      classes={{
        ...classes,
        root: `${styles.root} ${classes.root}`,
        label: `${styles.label} ${classes.label}`,
        disabled: `${styles.disabled} ${classes.disabled}`,
      }}
      control={<Checkbox />}
    />
  );
}

FormControlCheckbox.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

FormControlCheckbox.defaultProps = {
  classes: {},
};

export default FormControlCheckbox;
